import { render, staticRenderFns } from "./TicketsOverview.vue?vue&type=template&id=fb9fd446&scoped=true"
import script from "./TicketsOverview.vue?vue&type=script&lang=js"
export * from "./TicketsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9fd446",
  null
  
)

export default component.exports